import angular from 'angular'

import { has, wrap, uniqueId } from 'lodash-es'

import envRaw from '../utils/env-raw'

import Template from './gallery-empty.component.ejs'

angular
  .module('ggs.gallery-empty')
  .component('ggsGalleryEmpty', {
    template: Template({
      LE: envRaw.liveEditMode
    }),
    controller: GalleryEmptyComponent,
    bindings: {
      ggsStylerNew: '<',
      ggsProperties: '<',
      ggsShowsComponent: '<?'
    }
  })

function GalleryEmptyComponent(
  qh,
  $log,
  $scope,
  animate,
  $element,
  DefineMethod,
  DefineHandler,
  GalleryEmptyStyleHandlers) {

  const sign = `galleryEmpty[uid=${uniqueId()}]`
  const $ctrl = $scope.$ctrl = this
  $ctrl.wrapH = DefineHandler(sign)
  $ctrl.wrapM = DefineMethod(sign)
  const styleHandlers = GalleryEmptyStyleHandlers()

  const baseArg = { elm: $element }
  const hideArg = { elm: $element, transition: 'opacity 0.1s' }

  // $onInit
  $ctrl.wrapM('attachToStyler',
    qh.makeCatch(
      wrap(styleHandlers, $ctrl.ggsStylerNew.reg),
      wrap(`${sign}#attachToStyler: error halted:`, $log.error)))

  $ctrl.wrapH('$onInit',
    $ctrl.attachToStyler)

  // $onDestroy
  $ctrl.wrapH('$onDestroy',
    wrap(styleHandlers, $ctrl.ggsStylerNew.release))

  // show\hide
  $ctrl.wrapM('show', animate.makeShow(baseArg))
  $ctrl.wrapM('hide', animate.makeHide(hideArg))

  if (has($ctrl, 'ggsShowsComponent')) {
    animate.hideForce(baseArg)

    $ctrl.wrapH('changeHandler',
      qh.makeIfElse(
        $ctrl.ggsShowsComponent,
        $ctrl.show,
        $ctrl.hide))

    $scope.$watch(
      $ctrl.ggsShowsComponent,
      $ctrl.changeHandler)
  }
}
